import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  
  return children;
};

export const RequireAccess = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.has_access) return <Navigate to="/abonnement" replace />;
  
  return children;
};
